/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import { ListAttachmentsQueryVariables } from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const AttachmentCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listAttachments: {
        keyArgs: ['input', ['source', 'sourceId']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListAttachmentsQueryVariables>(
            existing,
            incoming,
            variables as ListAttachmentsQueryVariables
          );
        },
      },
    },
  },
};

export { AttachmentCacheTypePolicies };
